<div class="history-container">
  <!-- Header Section -->
  <div class="history-header mb-4">
    <div class="d-flex justify-content-between align-items-center">
      <div>
        <h3 class="mb-1">Report History</h3>
        <p class="text-muted mb-0">
          View and download generated reports
          @if (totalReportsGenerated() > 0) {
            <span class="ms-2">•</span>
            <span class="ms-2 fw-semibold">{{ totalReportsGenerated() }} reports generated</span>
          }
        </p>
      </div>
    </div>
  </div>

  <!-- Filters Card -->
  <div class="card mb-3">
    <div class="card-body">
      <div class="row g-3 align-items-end">
        <div class="col-lg-3">
          <label class="form-label small fw-semibold">Status</label>
          <select
            class="form-select form-select-sm"
            [(ngModel)]="statusFilter"
            (ngModelChange)="onFilterChange()"
          >
            @for (option of statusOptions; track option.value) {
              <option [value]="option.value">{{ option.label }}</option>
            }
          </select>
        </div>

        <div class="col-lg-3">
          <label class="form-label small fw-semibold">Report Type</label>
          <select
            class="form-select form-select-sm"
            [(ngModel)]="reportTypeFilter"
            (ngModelChange)="onFilterChange()"
          >
            @for (option of reportTypeOptions(); track option.value) {
              <option [value]="option.value">{{ option.label }}</option>
            }
          </select>
        </div>

        <div class="col-lg-3">
          <label class="form-label small fw-semibold">Date Range</label>
          <div class="btn-group w-100" role="group">
            <button
              type="button"
              class="btn btn-sm"
              [class.btn-secondary]="dateRangeFilter === 7"
              [class.btn-outline-secondary]="dateRangeFilter !== 7"
              (click)="setQuickDateRange(7)"
            >
              7 Days
            </button>
            <button
              type="button"
              class="btn btn-sm"
              [class.btn-secondary]="dateRangeFilter === 30"
              [class.btn-outline-secondary]="dateRangeFilter !== 30"
              (click)="setQuickDateRange(30)"
            >
              30 Days
            </button>
            <button
              type="button"
              class="btn btn-sm"
              [class.btn-secondary]="dateRangeFilter === 90"
              [class.btn-outline-secondary]="dateRangeFilter !== 90"
              (click)="setQuickDateRange(90)"
            >
              90 Days
            </button>
          </div>
        </div>

        <div class="col-lg-3">
          <button
            class="btn btn-sm btn-outline-secondary w-100"
            (click)="clearFilters()"
          >
            Clear Filters
          </button>
        </div>
      </div>
    </div>
  </div>

  <!-- Datatable -->
  <app-datatable
    #historyTable
    [data-href]="datatableUrl"
    [columns]="datatableColumns"
    [initialFilters]="initialFilters"
    [useOData]="true"
  ></app-datatable>

  <!-- Multi-Customer Download Modal -->
  @if (selectedJobForDownload()) {
    <div class="modal fade show d-block" tabindex="-1" style="background-color: rgba(0,0,0,0.5)">
      <div class="modal-dialog modal-dialog-centered modal-lg" style="max-height: 90vh;">
        <div class="modal-content" style="max-height: 90vh; display: flex; flex-direction: column;">
          <div class="modal-header">
            <h5 class="modal-title">Download Reports - {{ selectedJobForDownload()!.report_template?.name }}</h5>
            <button type="button" class="btn-close" (click)="closeDownloadModal()"></button>
          </div>
          <div class="modal-body" style="overflow-y: auto; flex: 1 1 auto;">
            <div class="mb-3">
              <p class="text-muted mb-3">
                This job generated reports for <strong>{{ getModalOrganizationCount() }} customer(s)</strong>@if (isAggregateJob(selectedJobForDownload()!)) { <span class="badge bg-info text-white">Aggregated into a single file</span>}.
                You can download all reports or individual reports below.
              </p>

              <!-- Download All Button -->
              <div class="d-grid mb-4">
                <button
                  class="btn btn-primary btn-lg"
                  [disabled]="!selectedJobForDownload()!.download_all_url"
                  (click)="downloadAllReports(selectedJobForDownload()!)"
                >
                  📦 Download All Reports
                </button>
              </div>

              <!-- Individual Customer Reports -->
              <div class="card">
                <div class="card-header bg-light sticky-top">
                  <h6 class="mb-0">Individual Customer Reports</h6>
                </div>
                <div class="list-group list-group-flush" style="max-height: 400px; overflow-y: auto;">
                  @for (customer of getCustomerDetails(selectedJobForDownload()!); track customer.id) {
                    <div class="list-group-item d-flex justify-content-between align-items-center">
                      <div>
                        <div class="fw-semibold">{{ customer.name }}</div>
                        <div class="text-muted small">Organization ID: {{ customer.id }}</div>
                      </div>
                      <button
                        class="btn btn-sm btn-outline-primary"
                        [disabled]="!customer.downloadUrl"
                        (click)="downloadSingleReport(customer.downloadUrl!)"
                      >
                        📥 Download
                      </button>
                    </div>
                  }
                </div>
              </div>
            </div>
          </div>
          <div class="modal-footer">
            <button type="button" class="btn btn-secondary" (click)="closeDownloadModal()">Close</button>
          </div>
        </div>
      </div>
    </div>
  }

  <!-- Aggregated Report Customers Modal -->
  @if (selectedJobForCustomers()) {
    <kendo-dialog
      title="Customers"
      (close)="closeCustomersModal()"
      [width]="500"
      [height]="500"
    >
      <div style="overflow-y: auto; max-height: 380px">
        <div class="list-group list-group-flush">
          @for (customer of getAggregatedCustomers(selectedJobForCustomers()!); track customer.id) {
            <div class="list-group-item">
              <div class="fw-semibold">{{ customer.name }}</div>
              <div class="text-muted small">Organization ID: {{ customer.id }}</div>
            </div>
          }
        </div>
      </div>
    </kendo-dialog>
  }
</div>
